import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";

import LoginForm from "./LoginForm";
import ResetPassword from "./ResetPassword";
import VerifyCode from "./VerifyCode";
import MobileLogin from "./MobileLogin";
import AuthContext from "../../contexts/AuthProvider";
import { useTranslation } from "react-i18next";
import { usePasswordResetDeepLink } from "./usePasswordResetDeepLink";

function Login() {
  const { t } = useTranslation("login");
  const [isResetPass, setIsResetPass] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { isAuthenticated } = useContext(AuthContext);
  const navigate = useNavigate();
  const { showResetVerify, resetVerifyEmail, verificationCodeFromUrl } =
    usePasswordResetDeepLink();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard");
    }
  }, [isAuthenticated, navigate]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // If width <= 700px, show MobileLogin instead
  if (windowWidth <= 700) {
    return <MobileLogin />;
  }

  // Otherwise, show the original desktop view
  return (
    <>
      <div className="login-container">
        <div className="login-left">
          <div className="login-logo">
            <img src="/logo.svg" alt={t("logoAlt")} />
          </div>
          <div className="login-background">
            <div className="text-login">
              <h1 className="title-login">
                {t("title")}
              </h1>
              <p className="subtitle-login">
                {t("subtitle")}
              </p>
            </div>
          </div>
        </div>
        <div className="login-right">
          <div className="login-form-container">
            {showResetVerify ? (
              <VerifyCode
                key={`${resetVerifyEmail}-${verificationCodeFromUrl}`}
                email={resetVerifyEmail}
                initialCode={verificationCodeFromUrl}
                setIsResetPass={setIsResetPass}
              />
            ) : !isResetPass ? (
              <LoginForm setIsResetPass={setIsResetPass} />
            ) : (
              <ResetPassword setIsResetPass={setIsResetPass} />
            )}
          </div>
        </div>
      </div>
      <div className="Mobile-login"></div>
    </>
  );
}

export default Login;
